/**
 * GA4 custom event tracking via GTM dataLayer.
 * Single delegated listener; targets elements by data-ga-* attributes only.
 * No gtag() - dataLayer.push() only.
 */
(function () {
  'use strict';

  function init() {
    window.dataLayer = window.dataLayer || [];

    /**
     * Collect all data-ga-* attributes from element (except data-ga-event, data-ga-accordion, data-ga-accordion-btn, data-ga-tab, data-ga-form).
     * Converts data-ga-label="x" -> { label: "x" } (camelCase).
     */
    function getGaParams(el) {
      var params = {};
      if (!el || !el.attributes) return params;
      for (var i = 0; i < el.attributes.length; i++) {
        var a = el.attributes[i];
        if (a.name.indexOf('data-ga-') === 0) {
          var key = a.name.slice(8);
          if (key === 'event' || key === 'accordion' || key === 'accordion-btn' || key === 'tab' || key === 'form') continue;
          var camel = key.replace(/-([a-z])/g, function (_, c) { return c.toUpperCase(); });
          params[camel] = a.value;
        }
      }
      return params;
    }

    function pushEvent(eventName, params) {
      var payload = { event: eventName };
      if (params && Object.keys(params).length) {
        for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) payload[k] = params[k];
      }
      window.dataLayer.push(payload);
      if (typeof console !== 'undefined' && console.log) {
        console.log('[GA4]', eventName, payload);
      }
    }

    // ----- Click delegation: data-ga-event, data-ga-accordion-btn, data-ga-tab -----
    document.addEventListener('click', function (e) {
      var target = e.target.closest && e.target.closest('[data-ga-event]');
      if (target) {
        var eventName = target.getAttribute('data-ga-event');
        if (eventName) {
          pushEvent(eventName, getGaParams(target));
        }
        return;
      }

      target = e.target.closest && e.target.closest('[data-ga-tab]');
      if (target) {
        var tabLabel = target.getAttribute('data-ga-tab');
        if (tabLabel === '' || tabLabel === null) tabLabel = (target.innerText || target.textContent || '').trim();
        pushEvent('ingredient_tab-change', Object.assign({ tab_label: tabLabel }, getGaParams(target)));
        return;
      }

      target = e.target.closest && e.target.closest('[data-ga-accordion-btn]');
      if (target) {
        var accordionEventName = target.getAttribute('data-ga-accordion-btn');
        if (accordionEventName) {
          setTimeout(function () {
            if (target.getAttribute('aria-expanded') === 'true') {
              pushEvent(accordionEventName, getGaParams(target));
            }
          }, 50);
        }
        return;
      }
    }, true);

    // ----- Accordion (details): fire only when opening -----
    document.addEventListener('toggle', function (e) {
      var details = e.target;
      if (details.nodeName && details.nodeName.toLowerCase() !== 'details') return;
      var eventName = details.getAttribute && details.getAttribute('data-ga-accordion');
      if (!eventName) return;
      if (details.open) {
        pushEvent(eventName, getGaParams(details));
      }
    }, true);

    // ----- Form submit: data-ga-form on <form> or ancestor -----
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.nodeName && form.nodeName.toLowerCase() !== 'form') return;
      var eventName = form.getAttribute && form.getAttribute('data-ga-form');
      if (!eventName && form.closest) {
        var wrapper = form.closest('[data-ga-form]');
        if (wrapper) eventName = wrapper.getAttribute('data-ga-form');
      }
      if (!eventName) return;
      var paramsEl = form.hasAttribute && form.hasAttribute('data-ga-form') ? form : form.closest && form.closest('[data-ga-form]');
      pushEvent(eventName, paramsEl ? getGaParams(paramsEl) : {});
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
